import type { IconComponent } from '../../icons/createIcon'
import { cx } from '../../cx'

export interface IconProps {
  /** An icon from `@bloo-team/ui/icons`. Import it where you build your nav/actions map. */
  icon: IconComponent
  size?: number
  strokeWidth?: number
  className?: string
  /**
   * Accessible label. Omit it when the icon sits next to visible text — a
   * decorative icon must be hidden from assistive tech, not double-announced.
   */
  label?: string
}

/**
 * The legacy console used FontAwesome Pro (`far fa-*`), which is a paid licence
 * and therefore out under PLAN.md D18. Lucide is ISC and covers the same ground,
 * and since 2026-09-17 the set is vendored into this repository rather than
 * installed from npm — see `docs/icons.md`.
 */
export function Icon({ icon: Cmp, size = 16, strokeWidth = 1.75, className, label }: IconProps) {
  return (
    <Cmp
      size={size}
      strokeWidth={strokeWidth}
      className={cx('bui-icon', className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    />
  )
}
